export const ADMIN = {
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginSubmit: 'admin-login-submit',
  loginError: 'admin-login-error',
  logout: 'admin-logout',
  navDashboard: 'admin-nav-dashboard',
  navSubscribers: 'admin-nav-subscribers',
  navInbox: 'admin-nav-inbox',
  navUsers: 'admin-nav-users',
  navProviders: 'admin-nav-providers',
  navPlans: 'admin-nav-plans',
  navSubscriptions: 'admin-nav-subscriptions',
  navMt5: 'admin-nav-mt5',
  navTeam: 'admin-nav-team',
  navMarketing: 'admin-nav-marketing',
  navMailbox: 'admin-nav-mailbox',
  navAudit: 'admin-nav-audit',
  usersSearch: 'admin-users-search',
  usersTierFilter: 'admin-users-tier',
  usersStatusFilter: 'admin-users-status',
  userRow: 'admin-user-row',
  userDetail: 'admin-user-detail',
  userActionSuspend: 'admin-user-action-suspend',
  userActionReactivate: 'admin-user-action-reactivate',
  userActionExtendTrial: 'admin-user-action-extend-trial',
  userActionGrantFree: 'admin-user-action-grant-free',
  providerRow: 'admin-provider-row',
  providerApprove: 'admin-provider-approve',
  providerReject: 'admin-provider-reject',
  providerFeature: 'admin-provider-feature',
  providerSuspend: 'admin-provider-suspend',
};
